import { Box } from '@alf/uikit';
import { useConfig } from '@namespace/cms';
import SettingsComponentsList from '../../common/SettingsComponentsList';

import styles from './index.module.css';

const Settings = ({ id }) => {
  const { config = {} } = useConfig(id);

  return (
    <Box data-role="settings-wrapper" className={styles.wrapper}>
      <SettingsComponentsList config={config} languageSelectSize="s" />
    </Box>
  );
};

export default Settings;
